import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"font-size":"18px","text-align":"left","padding-left":"10px","padding-bottom":"5px"} }


import { useStore } from 'vuex';
import KeyRow from './keyRow.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'keyBlock',
  props: {
    header: {},
    rows: {}
  },
  setup(__props: any) {

const store = useStore();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["divider-with-text", { 'dark-mode': _unref(store).state.dark }])
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.header), 1)
      ], 2)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
      return (_openBlock(), _createBlock(KeyRow, {
        key: index,
        color: row.color,
        territory: row.territory
      }, null, 8, ["color", "territory"]))
    }), 128))
  ]))
}
}

})